import { render, staticRenderFns } from "./QuizEditForm.vue?vue&type=template&id=035ea89e&scoped=true&"
import script from "./QuizEditForm.vue?vue&type=script&lang=js&"
export * from "./QuizEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035ea89e",
  null
  
)

export default component.exports